module.exports = __webpack_public_path__ + "img/ZB53详情页_09.91beb70d.jpg";